import { render, staticRenderFns } from "./config013-security.vue?vue&type=template&id=c16048f6&"
import script from "./config013-security.vue?vue&type=script&lang=js&"
export * from "./config013-security.vue?vue&type=script&lang=js&"
import style0 from "./config013-security.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports